
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[doctor_slug]",
      function () {
        return require("private-next-pages/doctors/[doctor_slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doctors/[doctor_slug]"])
      });
    }
  